import React from 'react';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import FavouriteButton from '../../buttons/FavouriteButton';
import CommentButton from '../../buttons/CommentButton';
import ShareButton from '../../buttons/ShareButton';
import AddToGroupButton from '../../buttons/AddToGroupButton';
import MoreButton from '../../buttons/MoreButton';
import DeleteButton from '../../buttons/DeleteButton';
import EditButton from '../../buttons/EditButton';
import { useDeviationAttributes } from '../../_partials/hooks/useDeviationAttributes';
import CommissionPointsAndPrice from '../../../CommissionPointsAndPrice';
import { useFlag } from '../../../redux/flags/hooks';
import s from './MobileActionBar.scss';
export var MobileActionBar = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner;
    var _b = useDeviationAttributes(deviation, isOwner), isCommentable = _b.isCommentable, isEditable = _b.isEditable, isFavouritable = _b.isFavouritable, isGroupSubmittable = _b.isGroupSubmittable, isReportable = _b.isReportable, isShareable = _b.isShareable, isDeletable = _b.isDeletable;
    var moneyValueEnabled = useFlag('money_value_commissions');
    var commission = deviation.commission;
    return (React.createElement(ActionBarStrip, { className: s['root'] },
        moneyValueEnabled && commission && (React.createElement("div", { className: s['commissions-wrapper'] },
            React.createElement(CommissionPointsAndPrice, { points: commission.pointsCost, price: commission.dollarsCost }))),
        React.createElement("div", { className: s['icons-wrapper'] },
            React.createElement("div", { className: s['left-block'] },
                isFavouritable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(FavouriteButton, { deviation: deviation, actionBarType: "primary" }))),
                isCommentable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(CommentButton, { deviation: deviation, isOwner: isOwner }))),
                isShareable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(ShareButton, { deviation: deviation }))),
                isGroupSubmittable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(AddToGroupButton, { deviation: deviation })))),
            React.createElement("div", { className: s['right-block'] },
                isReportable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(MoreButton, { deviation: deviation }))),
                isDeletable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(DeleteButton, { deviation: deviation }))),
                isEditable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(EditButton, { deviation: deviation })))))));
};
MobileActionBar.displayName = 'MobileActionBar';
export default MobileActionBar;
//# sourceMappingURL=MobileActionBar.js.map